import React from "react";
import { MessageCircle, TrendingUp, Users, Coins } from "lucide-react";
import { resellerWaLink, RESELLER_GENERIC_MSG } from "../../data/reseller";

const STATS = [
  { icon: Users, label: "Clientes ativos", value: "128" },
  { icon: Coins, label: "Créditos no painel", value: "42" },
  { icon: TrendingUp, label: "Lucro do mês", value: "R$ 2.340" },
];

const PanelPreview = () => (
  <div className="relative w-full max-w-md mx-auto lg:mx-0 lg:ml-auto rise" style={{ animationDelay: "200ms" }}>
    <div className="absolute -inset-6 bg-brand-gradient opacity-20 blur-3xl rounded-full pointer-events-none" />
    <div className="relative rounded-3xl border border-white/10 bg-surface/80 backdrop-blur-xl p-6 shadow-2xl shadow-brand/20">
      <p className="text-xs uppercase tracking-[0.25em] text-silver/70 font-bold">Painel do revendedor</p>
      <div className="mt-5 space-y-3">
        {STATS.map(({ icon: Icon, label, value }) => (
          <div key={label} className="flex items-center gap-4 p-4 rounded-2xl bg-ink/60 border border-white/5">
            <span className="w-11 h-11 rounded-xl bg-brand/15 border border-brand/30 flex items-center justify-center">
              <Icon className="w-5 h-5 text-brand-2" />
            </span>
            <div className="flex-1">
              <p className="text-xs text-silver/70">{label}</p>
              <p className="text-xl font-extrabold text-white tabular-nums">{value}</p>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-4 text-[11px] text-silver/50">Ilustração do painel</p>
    </div>
  </div>
);

export const ResellerHero = () => (
  <section className="relative overflow-hidden">
    <div className="absolute top-[-200px] left-[-150px] w-[520px] h-[520px] rounded-full bg-brand/20 blur-[140px] pointer-events-none" />
    <div className="max-w-[1300px] mx-auto px-5 md:px-6 py-16 md:py-24 grid lg:grid-cols-2 gap-12 items-center">
      <div className="rise">
        <p className="text-xs md:text-sm font-bold uppercase tracking-[0.3em] brand-gradient-text">Programa de Revenda</p>
        <h1 data-testid="reseller-hero-title" className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
          Seja um Revendedor <span className="brand-gradient-text">MasterX</span>
        </h1>
        <p className="mt-5 text-base md:text-lg text-silver/85 max-w-xl leading-relaxed">
          Tenha seu próprio negócio de streaming com painel exclusivo, créditos que não expiram e suporte dedicado. Você define o preço e fica com o lucro.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <a
            href={resellerWaLink(RESELLER_GENERIC_MSG)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reseller-hero-cta"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-brand-gradient text-white font-bold shadow-xl shadow-brand/30 hover:brightness-110 hover:-translate-y-0.5 transition"
          >
            <MessageCircle className="w-5 h-5" /> Quero ser revendedor
          </a>
          <a href="#pacotes" data-testid="reseller-hero-packages-link" className="inline-flex items-center px-7 py-4 rounded-full border border-white/15 hover:bg-white/5 text-white font-semibold transition-colors">
            Ver pacotes
          </a>
        </div>
      </div>
      <PanelPreview />
    </div>
  </section>
);
